import React from 'react';
import { PropTypes } from 'prop-types';

function LanguageTab({ children }) {
  return <div className="tab-content-containter bg-greyWithinForm rounded-b-lg pt-4">{children}</div>;
}

LanguageTab.propTypes = {
  children: PropTypes.shape().isRequired,
};

export default LanguageTab;
